module.exports = "<div id=\"dialog-pdf\" class=\"dialog pdf\">\r\n  <div class=\"dialog-header\">\r\n    {{data.title}}\r\n  </div>\r\n  <div class=\"dialog-content pdf\" style=\"overflow:auto;-webkit-overflow-scrolling:touch\">  </div>\r\n  <div class=\"dialog-footer d-flex justify-content-between\">\r\n\r\n    <button class=\"btn left m-sm-0 m-auto\" *ngFor=\"let btn of data.footer\" (click)=\"CloseMe(btn.value)\">{{btn.label}}</button>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/shared/dialogs/pdf.component.html
// module id = ZSNt
// module chunks = 0